import React, { useMemo, useState } from "react";
import { makeStyles, TextField } from "@material-ui/core";
import { highlightColorRGBA } from "./HighlightColor";
import useReactiveFunctionWithDebouncing from "./useReactiveFunctionWithDebouncing";

const useStyles = makeStyles((theme) => ({
  maintainBorderStylesWhenHighlighted: {
    overflow: 'hidden',
  }
}));

export default function HighlightableTextField({ isHighlightedFunction, safeToHighlight = true, className, InputProps, ...props }) {
  const { value } = props;
  const [highlighted, setHighlighted] = useState(false);
  const classes = useStyles();
  
  const InputPropsOverride = useMemo(() => ({
    ...InputProps,
    style: {
      ...InputProps?.style,
      backgroundColor: highlighted ? highlightColorRGBA : InputProps?.style?.backgroundColor,
    }
  }), [highlighted, InputProps]);
  
  useReactiveFunctionWithDebouncing({
                                      functionn: isHighlightedFunction,
                                      reactiveArgument: value,
                                      safeToRun: safeToHighlight,
                                      setReturnedValue: setHighlighted,
                                    });
  
  
  return (
    <TextField {...props} className={`${className ?? ''} ${classes.maintainBorderStylesWhenHighlighted}`} InputProps={InputPropsOverride}/>
  );
}